<script setup lang="ts">
import Button from '@components/global/button.vue'
</script>

<template>
	<section class="container">
		<div class="flex h-full flex-col gap-14 lg:flex-row lg:gap-20">
			<div class="flex w-full flex-col items-center gap-4 text-center lg:w-[40%] lg:items-start lg:gap-8 lg:text-start">
				<span class="label-medium text-red-base">/// about ether</span>
				<div class="d1 relative mt-0 flex gap-4 uppercase text-default sm:mt-10 lg:mt-0 lg:flex-col lg:gap-2">
					<div>
						<span class="font-heading-semibold">wh</span>
						<span>o</span>
						<div class="block lg:hidden">
							<span class="font-heading-semibold">w</span>
							<span>e ar</span>
							<span class="font-heading-semibold">e</span>
						</div>
					</div>
					<div class="hidden lg:block">
						<span class="font-heading-semibold">w</span>
						<span>e ar</span>
						<span class="font-heading-semibold">e</span>
					</div>
					<div class="absolute left-[-5%] top-[-8%]">
						<img src="https://cdn.projectether.co/images/home-page/home-who-we-are-circle.svg" class="w-full bg-no-repeat mix-blend-exclusion" alt="" />
					</div>
				</div>
				<p class="md text-default">ETHER is a brand created by V. We aim to bridge the gap between multiple industries, such as fashion, anime and technology all while working alongside our community. We will create new and exciting experiences both in the physical and digital realm. We wish to uplift the world and individuals in various ways. ETHER is a brand shaped by the people, for the people.</p>
				<Button :to="{ name: 'about' }" class="default" icon="fa-solid fa-arrow-up-right">About Us</Button>
			</div>
			<div class="animation-container relative flex w-full items-center lg:w-[60%]">
				<img src="https://cdn.projectether.co/images/home-page/home-who-we-are-dots.svg" class="absolute bottom-0 left-0 right-0 top-0 h-full w-full" alt="" />
				<img src="https://cdn.projectether.co/images/home-page/home-who-we-are.png" class="animation relative origin-top-left" alt="" />
			</div>
		</div>
	</section>
</template>

<style scoped>
.animation-container:hover .animation {
	transform-origin: top left;
	rotate: -10deg;
	transition: all;
	transition-duration: 1000ms;
}

.animation-container .animation {
	rotate: 0;
	transition: all;
	transition-duration: 1000ms;
}
</style>
